import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useViewContext from '@modules/order/hooks/use-view-context'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import formatNumberByLocale from '@utils/format-number-by-locale'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { CentricTypography } from '@core/component/CentricTypography'
import { CATEGORY_INTERNAL_SEPERATOR } from '@modules/order/constants/uiConstants'
import { InitialAllocationUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/InitialAllocationUIStore'
import { InitialAllocationDataStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/InitialAllocationDataStore'

const IAProductHeirarchyDetailsCell: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const { uiStore } = useViewContext()
    if (!rowData) {
      return (
        <HierarchyCell>
          <FieldSkeleton />
        </HierarchyCell>
      )
    }
    const {
      getOrderHierarchyKPIs,
      dataStore: { heirarchy }
    } = uiStore as InitialAllocationUIStore<InitialAllocationDataStore>
    const hierarchy = getOrderHierarchyKPIs(rowData?.name, heirarchy)
    const isMainHeirarchy = !rowData?.name?.includes(CATEGORY_INTERNAL_SEPERATOR)

    return (
      <HierarchyCell data-test-id={'IAProductHeirarchyDetailsCell'}>
        <CentricTypography variant={isMainHeirarchy ? 'subtitle1' : 'caption'}>
          {`${formatNumberByLocale(
            hierarchy?.[column.enhancedField] || 0,
            0,
            2
          )} / ${formatNumberByLocale(
            hierarchy?.[column.initialAllocationField] || 0,
            0,
            2
          )}`}
        </CentricTypography>
      </HierarchyCell>
    )
  })

export default IAProductHeirarchyDetailsCell
